<template>
	<div class="flex justify-center">
		<RadarChart
			:scores="scores"
			:labels="chartLabels"
			:colors="colors"
			:max-score="maxScore"
			:size="canvasSize"
			:aria-label="ariaLabel"
		/>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { SectionId } from '@/data/learningTest';
import { getSectionShortTitle } from '@/utils/sectionHelpers';
import RadarChart from '@monorepo/shared-ui/components/RadarChart.vue';

interface Props {
	scores: Record<string, number>;
	labels?: string[];
	colors?: string[];
	maxScore?: number;
	canvasSize?: number;
	ariaLabel?: string;
}

const props = withDefaults(defineProps<Props>(), {
	labels: undefined,
	colors: () => ['#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#dc2626', '#ec4899'],
	maxScore: 50,
	canvasSize: 500,
	ariaLabel: 'Lernpräferenzen Radar Diagramm',
});

/**
 * Compute labels for the chart.
 * If labels prop is provided, use it.
 * Otherwise, map score keys to short titles using sectionHelpers (translation).
 */
const chartLabels = computed(() => {
	if (props.labels) return props.labels;
	
	return Object.keys(props.scores).map((key) => getSectionShortTitle(key as SectionId));
});
</script>
